export const TYPES = [
	{
		"id": 1, name: "Trong"
	},
	{
		"id": 2, name: "Ngoài"
	}
]